var _excluded = ["children", "read", "sentAt", "id", "campaignName"];
var _jsxFileName = "/repo/packages/webassets/src/components/Header/wrench/components/info-menu/NotificationItem.tsx",
  _this = this;
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import { useMutation } from 'react-apollo';
import { MetricsTracker, USER_EVENTS } from '@sm/metrics';
import { FormattedDateTime, FormattedRelativeTime } from '@sm/intl';
import { sanitizeString } from '@sm/utils';
import { safeRest } from '@wds/utils';
import { Box } from '@wds/box';
import { Typography } from '@wds/typography';
import notificationsMarkAsReadQuery from './NotificationsMarkAsRead.graphql';
import useStyles from './useStylesNotificationItem';
var NotificationItem = function NotificationItem(_ref) {
  var children = _ref.children,
    _ref$read = _ref.read,
    read = _ref$read === void 0 ? false : _ref$read,
    sentAt = _ref.sentAt,
    id = _ref.id,
    campaignName = _ref.campaignName,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useStyles = useStyles({
      read: read
    }),
    notificationsItem = _useStyles.notificationsItem;
  var _useMutation = useMutation(notificationsMarkAsReadQuery),
    _useMutation2 = _slicedToArray(_useMutation, 1),
    clickInProductMessage = _useMutation2[0];
  var trackNotificationsEvent = function trackNotificationsEvent() {
    MetricsTracker.track({
      name: USER_EVENTS.ELEMENT_INTERACTION,
      data: {
        amplitudeEvent: 'notification center interaction',
        interactionType: 'click',
        interactionLocation: 'mark as read',
        campaignName: campaignName
      }
    });
  };
  var _onClick = function onClick(e) {
    var target = e.target;
    if (target.tagName !== 'A') {
      return;
    }
    e.preventDefault();
    var href = target.getAttribute('href');
    clickInProductMessage({
      variables: {
        input: {
          id: id,
          linkUrl: href
        }
      }
    });
    trackNotificationsEvent();
    if (href) {
      window.location = href;
    }
  };
  var date = /*#__PURE__*/React.createElement(FormattedRelativeTime, {
    value: new Date(sentAt),
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 68,
      columnNumber: 16
    }
  });
  var time = /*#__PURE__*/React.createElement(FormattedDateTime, {
    value: new Date(sentAt),
    hour: "numeric",
    minute: "numeric",
    hour12: true,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 70,
      columnNumber: 5
    }
  });
  return /*#__PURE__*/React.createElement("li", Object.assign({
    className: notificationsItem
  }, safeRest(rest), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 79,
      columnNumber: 5
    }
  }), /*#__PURE__*/React.createElement(Box, {
    mb: 2,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 80,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    component: "p",
    variant: "bodySm",
    color: "darkMuted",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 81,
      columnNumber: 9
    }
  }, date, "\xA0\xA0\xA0", time)), /*#__PURE__*/React.createElement(Typography, {
    weight: !read ? 'medium' : 'regular',
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 85,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement("div", {
    onClick: function onClick(e) {
      return _onClick(e);
    },
    dangerouslySetInnerHTML: {
      __html: sanitizeString(children.toString())
    },
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 87,
      columnNumber: 9
    }
  })));
};
export default NotificationItem;
export { NotificationItem };
//# sourceMappingURL=NotificationItem.js.map